import styled, { css } from 'styled-components';
import { media } from 'styled-bootstrap-grid';

export type StyledClassProps = {
  isFull?: boolean;
  isSuspended?: boolean;
};

export type ClassColProps = {
  direction?: string;
  justify?: string;
  align?: string;
  isGrow?: boolean;
  isError?: boolean;
  numberColumn?: boolean;
};

export type NumberOfSpacesProps = {
  isError?: boolean;
};

export type ClassMessageProps = {
  isFull?: boolean;
  isSuspended?: boolean;
};

export const StyledClass = styled.div<StyledClassProps>`
  display: inline-flex;
  flex-direction: column;
  justify-content: space-between;
  background: '#FFFFFF';
  padding: 10px 5px;
  margin: 10px;
  width: 100%;
  color: ${({ theme }) => theme.defaultColors.fontSecondary};
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.125);

  ${({ isFull, theme }) =>
    isFull &&
    css`
      background: ${theme.defaultColors.successBackground};
    `}

  ${({ isSuspended, theme }) =>
    isSuspended &&
    css`
      background: ${theme.defaultColors.errorBackground};
    `}

  ${media.lg`
    width: calc(50% - 20px);
  `}

  ${media.xl`
    width: calc(33% - 20px);
  `}
`;

export const ClassRow = styled.div`
  display: flex;
  flex-direction: row;
`;

export const ClassCol = styled.div<ClassColProps>`
  display: flex;
  flex-direction: ${({ direction }) => direction || 'column'};
  justify-content: ${({ justify }) => justify || 'space-between'};
  align-items: ${({ align }) => align || 'flex-start'};
  line-height: 20px;
  padding: 0 10px;
  margin: 5px 0 6px;
  flex-shrink: 0;

  ${({ isGrow }) =>
    isGrow &&
    css`
      flex-shrink: 1;
      flex-grow: 1;
    `};

  ${({ isError }) =>
    isError &&
    css`
      padding-top: 10px;
    `};

  ${({ numberColumn }) =>
    numberColumn &&
    css`
      min-width: 88px;
    `};
`;

export const LeadingText = styled.div`
  font-size: 18px;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  line-height: 24px;
  margin-bottom: 2px;
`;

export const DurationWrapper = styled.span`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const NumberOfSpaces = styled.span<NumberOfSpacesProps>`
  ${({ isError, theme }) =>
    isError &&
    css`
      color: ${theme.defaultColors.error};
    `};
`;

export const ClassMessage = styled.div<ClassMessageProps>`
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
  color: ${({ theme }) => theme.defaultColors.fontSecondary};

  ${({ isFull, theme }) =>
    isFull &&
    css`
      text-transform: uppercase;
      color: ${theme.defaultColors.success};
    `}

  ${({ isSuspended, theme }) =>
    isSuspended &&
    css`
      text-transform: uppercase;
      color: ${theme.defaultColors.error};
    `}
`;
